import { z } from 'zod';

import { VALUATION_INDICATORS_LENGTH } from '@constants';

export const declarationViewCustomsTreatmentSchema = z.object({
  messageInfo: z.object({
    methodOfPayment: z.string().optional().nullable(),
    deferredPayment: z.string().optional().nullable(),
    deferredPaymentVAT: z.string().optional().nullable(),
    methodOfPaymentVAT: z.string().optional().nullable(),
  }),
  valuationInformationTaxes: z.object({
    globalChargesimport: z.object({
      CustomsCharges: z.object({
        charges: z.number().optional().nullable(),
        currency: z.string().optional().nullable(),
      }),
      VATcharges: z.object({
        charges: z.number().optional().nullable(),
        currency: z.string().optional().nullable(),
      }),
    }),
    chargesimport: z.object({
      CustomsCharges: z.object({
        charges: z.number().optional().nullable(),
        currency: z.string().optional().nullable(),
      }),
      VATcharges: z.object({
        charges: z.number().optional().nullable(),
        currency: z.string().optional().nullable(),
      }),
    }),
    valuationMethod: z.string().optional().nullable(),
    valuationAdjustment: z.object({
      valuationIndicators: z
        .string()
        .optional()
        .nullable()
        .refine((val) => !val || val.trim().length === VALUATION_INDICATORS_LENGTH, {
          message: 'Valuation indicators field is not valid',
        }),
    }),
  }),
  consignment: z.object({
    transportCost: z.object({
      amount: z.number().optional().nullable(),
      currencyCode: z.string().optional().nullable(),
    }),
  }),
});

export type DeclarationViewCustomsTreatmentFormValues = z.infer<typeof declarationViewCustomsTreatmentSchema>;
